import { Injectable } from '@angular/core';
import { FunctionsService } from './__common/functions.service';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  booking = {
    products: [],
    subtotal: 0,
    total: 0
  };
  token;
  locked = true;
  bookingTotal = 0;
  subtotal = 0;

  constructor(private commonFunctions: FunctionsService) { }


  addToCart(newObj){
    let orderProduct = {
      price: 0,
      quantity: 0
    };
    switch(newObj.type){
      case 'pack':
        debugger;
        orderProduct.price = parseFloat(newObj.data.price);
        this.booking.products.push(orderProduct)
        break;
      case 'product':
        orderProduct.price = parseFloat(newObj.price);
        this.booking.products.push(orderProduct)
      default: 
        debugger
    }
  }

  getCartItems(){
    return this.booking.products;
  }

/*   selectBooked(bookedObj){

    debugger
    this.subtotal = parseFloat(bookedObj.price);
    this.booking = bookedObj;
  } */

  getBooking(){
    return this.booking;
  }

  lock(){
    this.locked = true;
  }

  unlock(){
    this.locked = false;
  }

  isLocked(){
    return this.locked == true;
  }

  saveToken(token){
    this.token = token;
  }

  getToken(){
    return this.token;
  }

  getBookingTotal(){
    return this.bookingTotal;
  }

  setBookingTotal(){

  }

  calculateSubTotal(){
    if(this.booking){
      // PACK
      if(this.booking.products.length>0){
        for(let product of this.booking.products){
          this.subtotal += parseFloat(product.price);
        }
      }
    }
    return this.subtotal;
  }

  calculateTotal(){
    this.bookingTotal = this.subtotal + this.commonFunctions.calculateIva(this.subtotal);
    return this.bookingTotal;
  }
}
